import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { environment } from "./../../../../../../../environments/environments";

export type prayerTime = {
  time: string;
  name: string;
};

export interface ShabbatData {
  shabbatStart: string;
  shabbatEnd: string;
  hebrew: string;
  parasha: string;
  book: string;
  hazan: string[];
  prayerTimes: prayerTime[];
  orders: Array<{
    _id: string;
    userId: string;
    userName: string;
    name: string[];
    createdAt: string;
  }>;
}

@Injectable({
  providedIn: "root",
})
export class HebcalService {
  private API_URL = environment.API_URL;

  constructor(private http: HttpClient) {}

  /**
   * Fetch current Shabbat details and Hebrew date
   */
  async getHebrewDate(): Promise<ShabbatData> {
    return lastValueFrom(this.http.get<ShabbatData>(`${this.API_URL}/hebcal`));
  }

  /**
   * Fetch aliyot (Torah portions) by specific parasha
   * @param parasha - The parasha name (e.g., "בראשית")
   * @returns Promise with ShabbatData filtered by parasha
   */
  async getAliyotByParasha(
    parasha: string,
    year?: string
  ): Promise<ShabbatData | { msg: string; msgHeb?: string }> {
    if (!parasha?.trim()) {
      return Promise.reject({ msg: "Parasha is required" });
    }

    const encodedParasha = encodeURIComponent(parasha);
    const url = year
      ? `${this.API_URL}/hebcal/snapshot/${year}/${encodedParasha}`
      : `${this.API_URL}/hebcal/snapshot/${encodedParasha}`;

    try {
      return await lastValueFrom(this.http.get<ShabbatData>(url));
    } catch (err: any) {
      console.error("Failed to fetch aliyot by parasha:", err);

      // Return server error message if exists, fallback otherwise
      const serverMsg =
        err?.error?.msgHeb ||
        err?.error?.msg ||
        err?.message ||
        "Failed to fetch aliyot by parasha from server";

      return { msg: serverMsg };
    }
  }
}
